"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var drm = new _GatewayService["default"]('drm');
var basePath = 'api/drm/v1';

var fetchPublicKey = function fetchPublicKey() {
  return drm.get(basePath + '/user/publickey');
};

var fetchGlobalKey = function fetchGlobalKey() {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + '/user/globaldrmkey', config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchUserKey = function fetchUserKey() {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + '/user/drmkey', config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchSettings = function fetchSettings() {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + '/user/settings', config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchChecksum = function fetchChecksum() {
  return drm.get(basePath + '/user/checksum');
};

var fetchDeviceUpdates = function fetchDeviceUpdates(deviceId) {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + "/user/".concat(deviceId, "/updates"), config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var ping = function ping() {
  return drm.head(basePath + '/publication');
};

var fetchBooks = function fetchBooks() {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + '/publication', config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchBookDetails = function fetchBookDetails(bookId) {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + "/publication/".concat(bookId), config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var acquireBookLicense = function acquireBookLicense(bookId, deviceId) {
  var payload = {
    deviceId: deviceId
  };
  var config = {
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return drm.post(basePath + "/publication/".concat(bookId, "/titlekey"), payload, config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var revokeBookLicense = function revokeBookLicense(bookId, deviceId, validationToken) {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm["delete"](basePath + "/publication/".concat(bookId, "/device/").concat(deviceId, "/titlekey?validationToken=").concat(validationToken), config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchBookComponent = function fetchBookComponent(bookId, componentId) {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + "/publication/".concat(bookId, "/component/").concat(componentId), config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchBookResource = function fetchBookResource(bookId, resourceId) {
  var config = {
    responseType: 'arraybuffer'
  };
  return drm.get(basePath + "/publication/".concat(bookId, "/resource/").concat(resourceId), config).then(function (buffer) {
    return new Uint8Array(buffer);
  });
};

var fetchBookChecksum = function fetchBookChecksum(bookId) {
  return drm.get(basePath + "/publication/".concat(bookId, "/checksum"));
};

var searchBook = function searchBook(bookId, query) {
  return drm.get(basePath + "/publication/".concat(bookId, "/search/").concat(query));
};

var fetchDrmAssessmentActivityMarks = function fetchDrmAssessmentActivityMarks(unitKey, unitRevision, activityKey) {
  return drm.get(basePath + "/assessment-activity/marks/".concat(unitKey, "/").concat(unitRevision, "/").concat(activityKey));
};

var fetchDrmAssessmentActivityAudio = function fetchDrmAssessmentActivityAudio(unitKey, unitRevision, activityKey) {
  return drm.get(basePath + "/assessment-activity/audio/".concat(unitKey, "/").concat(unitRevision, "/").concat(activityKey));
};

var _default = {
  fetchPublicKey: fetchPublicKey,
  fetchGlobalKey: fetchGlobalKey,
  fetchUserKey: fetchUserKey,
  fetchSettings: fetchSettings,
  fetchChecksum: fetchChecksum,
  fetchDeviceUpdates: fetchDeviceUpdates,
  ping: ping,
  fetchBooks: fetchBooks,
  fetchBookDetails: fetchBookDetails,
  acquireBookLicense: acquireBookLicense,
  revokeBookLicense: revokeBookLicense,
  fetchBookComponent: fetchBookComponent,
  fetchBookResource: fetchBookResource,
  fetchBookChecksum: fetchBookChecksum,
  searchBook: searchBook,
  fetchDrmAssessmentActivityMarks: fetchDrmAssessmentActivityMarks,
  fetchDrmAssessmentActivityAudio: fetchDrmAssessmentActivityAudio
};
exports["default"] = _default;